import { render, staticRenderFns } from "./mediaPost.vue?vue&type=template&id=0e13f3da&scoped=true"
import script from "./mediaPost.vue?vue&type=script&lang=js"
export * from "./mediaPost.vue?vue&type=script&lang=js"
import style0 from "./mediaPost.vue?vue&type=style&index=0&id=0e13f3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e13f3da",
  null
  
)

export default component.exports